export default "__VITE_ASSET__BXoUpAvQ__"